export class Milestone {
	constructor(options) {
        options = options || {};
		this.id = _.parseNumber(options.id, 0);
        this.name = options.name || null;
        this.description = options.description || null;
		this.isEnabled = _.parseBool(options.isEnabled, true);
        this.displayOrder = _.parseNumber(options.displayOrder, 0);
        this.templateId = _.parseNumber(options.templateId, 0);
	}
    get isNew() { return this.id === 0; }

    get isValid() { return this.validationErrors.length === 0; }
    get validationErrors() {
        let errorList = [];
        if (_.isEmpty(this.name)) {
            errorList.push("Label is required.");
        }

        if (_.isEmpty(this.description)) {
            errorList.push("Description is required.");
        }

        return errorList;
    }

    toDataObject() { return _.toPlainObject(this); }
}

export class SnuTask {
	constructor(options) {
        options = options || {};
		this.id = _.parseNumber(options.id, 0);
        this.name = options.name || null;
        this.description = options.description || null;
		this.isEnabled = _.parseBool(options.isEnabled, true);
        this.displayOrder = _.parseNumber(options.displayOrder, 0);
        this.isInUseByOrder = options.isInUseByOrder || false;
        this.workflowTaskId = _.parseNumber(options.workflowTaskId, null);
        this.templateId = _.parseNumber(options.templateId, 0);
        this.assocWorkflowTaskName = options.assocWorkflowTaskName;
        this.milestoneId = _.parseNumber(options.milestoneId, null);
        this.contactRoleEntityId = _.parseNumber(options.contactRoleEntityId, null);
        this.action = _.parseNumber(options.action, null);
	}
    get isNew() { return this.id === 0; }

    get isValid() { return this.validationErrors.length === 0; }
    get validationErrors() {
        let errorList = [];
        if (_.isEmpty(this.name)) {
            errorList.push("Label is required.");
        }

        if (_.isEmpty(this.description)) {
            errorList.push("Description is required.");
        }

        return errorList;
    }

    toDataObject() { return _.toPlainObject(this); }
}

export class WorkflowTaskDto {
	constructor(options) {
        options = options || {};
		this.id = _.parseNumber(options.id, 0);
        this.name = options.name || null;
        this.description = options.description || null;
        this.otherWorkflowTaskId = _.parseNumber(options.otherWorkflowTaskId, 0);
        this.templateTypeId = _.parseNumber(options.templateTypeId, 0);
        this.regionName = options.regionName || null;
        this.departmentName = options.departmentName || null;
        this.assignedPerson = options.assignedPerson || null;
	}

    toSnuTask() { return new SnuTask({
            name: this.name,
            description: this.description || this.name,
            workflowTaskId: this.id,
            templateId: this.templateTypeId
        })
    }
}

export class AccountDocumentDto {
	constructor(options) {
        options = options || {};
        this.documentId = _.parseNumber(options.documentId, 0);
        this.userAccountId = _.parseNumber(options.userAccountId, 0);
        this.action = options.action || null;
        this.isSignable = _.parseBool(options.isSignable, false);
        this.isReviewed = _.parseBool(options.isReviewed, false);
	}
    get isNew() { return this.id === 0; }

    toDataObject() { return _.toPlainObject(this); }
}

export class BuildInfo {
	constructor(options) {
        options = options || {};
        this.buildEnv = options.buildEnv || null;
        this.image = options.image || null;
        this.gitHash = options.gitHash || null;
        this.gitBranch = options.gitBranch || null;
        this.buildDate = options.buildDate || null;
        this.dataPumpVersion = options.dataPumpVersion || null;
        this.extensionVersion = options.extensionVersion || null;
	}

    toDataObject() { return _.toPlainObject(this); }
}

export class ConfigurationSetting {
	constructor(options) {
        options = options || {};
		this.id = _.parseNumber(options.id, 0);
        this.property = options.property || null;
        this.dataType = options.dataType || null;
        this.description = options.description || null;
		this.value = options.value || "0";
		this.valueBool = _.isEqual(options.value, "1");
        this.postClosingAccessMonths = options.postClosingAccessMonths||"0";
        this.postClosingAccessMonthsDescription = options.postClosingAccessMonthsDescription || "";
        this.compileDocNotifTimeframeInMin = _.parseInt(options.compileDocNotifTimeframeInMin) || 0;
        this.sendCompiledDocNotifTimeframeMax = _.parseInt(options.sendCompiledDocNotifTimeframeMax) || 0;
        this.dataPumpVersion = options.dataPumpVersion || null;
        this.extensionVersion = options.extensionVersion || null;
		this.esignApplicationId = _.parseNumber(options.esignApplicationId, 1);
        this.showWiringInstructionsTab = _.parseBool(options.showWiringInstructionsTab, true);
        this.allowConsumerMfaOverride = _.parseBool(options.allowConsumerMfaOverride, true);
        this.bannerBackgroundColorHex = options.bannerBackgroundColorHex || null;
        this.bannerFontColorHex = options.bannerFontColorHex || null;
        this.systemType = options.systemType || null;
        this.storageAccount = options.storageAccount || null;
        this.otherTenantName = options.otherTenantName || null;
        this.otherDatabaseName = options.otherDatabaseName || null;
        this.otherContainerName = options.otherContainerName || null;
        this.invitationExpirationInHours = _.parseNumber(options.invitationExpirationInHours, 0);
        this.allowCreateOrder = _.parseBool(options.allowCreateOrder, false);
        this.idleTimeoutInMinutes = _.parseNumber(options.idleTimeoutInMinutes, 0);
	}

    toDataObject() { return _.toPlainObject(this); }
}

export const PredefinedActions = Object.freeze({
    "View Document": 1,
    "Sign Document": 2,
    "Upload Document": 3,
    "Seller Proceeds": 4,
    "Validate ID": 5,
});